export const routes = [
  {
    moduleType: 'main',
    pageType: 'home',
    path: '/',
    meta: {
      authRequired: true,
      signUpRequired: true,
      analyticDisabled: false,
    },
    component: () =>
      import(
        /* webpackChunkName: 'modules/main/page/home' */
        '~/modules/main/components/pages/home.vue'
      ),
  },
  {
    moduleType: 'main',
    pageType: 'roulette',
    path: '/roulette',
    meta: {
      authRequired: true,
      signUpRequired: true,
      analyticDisabled: false,
    },
    component: () =>
      import(
        /* webpackChunkName: 'modules/main/page/roulette' */
        '~/modules/main/components/pages/roulette.vue'
      ),
  },
  {
    moduleType: 'main',
    pageType: 'prizes',
    path: '/prizes',
    meta: {
      authRequired: true,
      signUpRequired: true,
      analyticDisabled: false,
    },
    component: () =>
      import(
        /* webpackChunkName: 'modules/main/pages/prizes' */
        '~/modules/main/components/pages/prizes.vue'
      ),
  },
  {
    moduleType: 'main',
    pageType: 'tasks',
    path: '/tasks',
    meta: {
      authRequired: true,
      signUpRequired: true,
      analyticDisabled: false,
    },
    component: () =>
      import(
        /* webpackChunkName: 'modules/main/pages/tasks' */
        '~/modules/main/components/pages/tasks.vue'
      ),
  },
  {
    moduleType: 'main',
    pageType: 'rating',
    path: '/rating',
    meta: {
      authRequired: true,
      signUpRequired: true,
      analyticDisabled: false,
    },
    component: () =>
      import(
        /* webpackChunkName: 'modules/main/pages/rating' */
        '~/modules/main/components/pages/rating.vue'
      ),
  },
  {
    moduleType: 'main',
    pageType: 'menu',
    path: '/menu',
    meta: {
      authRequired: true,
      signUpRequired: true,
      analyticDisabled: false,
    },
    component: () =>
      import(
        /* webpackChunkName: 'modules/main/pages/menu' */
        '~/modules/main/components/pages/menu.vue'
      ),
  },
  {
    moduleType: 'main',
    pageType: 'menu-faq',
    path: '/menu/faq',
    meta: {
      authRequired: true,
      signUpRequired: true,
      analyticDisabled: false,
    },
    component: () =>
      import(
        /* webpackChunkName: 'modules/main/pages/menu-faq' */
        '~/modules/main/components/pages/menu-faq.vue'
      ),
  },
]
